enum EnvMap {
  'local' = 'LOC',
  'development' = 'DEV',
  'stage' = 'STG',
  'production' = 'PRD'
}

/**
 * @description 환경변수 값을 가져 오는 함수
 * @param initEnv
 * @exmpale
 * initEnv = {API_BASE: {DEV: 'test'}, AUTHORIZATION_TOKEN: {DEV: 'test'}} 이고 환경이 development 일때
 * 반환되는 값 {API_BASE: 'test', AUTHORIZATION_TOKEN: 'test'}
 */
export default function (initEnv: Env) {
  const config = useRuntimeConfig()
  const mode = config.public.mode as BaseEnvKey
  const targetEnv = EnvMap[mode] // LOC, DEV, STG, PRD

  return Object.entries(initEnv).reduce(
    (acc, [key, value]) => {
      acc[key] = value[targetEnv] || ''
      return acc
    },
    {} as Record<string, string>
  )
}
